import { render, staticRenderFns } from "./shoplist_xq.vue?vue&type=template&id=39dc3acc&scoped=true&"
import script from "./shoplist_xq.vue?vue&type=script&lang=js&"
export * from "./shoplist_xq.vue?vue&type=script&lang=js&"
import style0 from "./shoplist_xq.vue?vue&type=style&index=0&id=39dc3acc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dc3acc",
  null
  
)

export default component.exports